import { render, staticRenderFns } from "./Concact.vue?vue&type=template&id=4318f740&scoped=true&"
import script from "./Concact.vue?vue&type=script&lang=js&"
export * from "./Concact.vue?vue&type=script&lang=js&"
import style0 from "./Concact.vue?vue&type=style&index=0&id=4318f740&prod&lang=less&"
import style1 from "./Concact.vue?vue&type=style&index=1&id=4318f740&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4318f740",
  null
  
)

export default component.exports